import { injectable } from 'tsyringe';
import { OWGameListener } from '../../odk-ts';
import { DelegateProvider } from 'app-core/src/interfaces/delegate-provider.interface';
import { IOWGameListenerWrapper } from 'app-core/src/interfaces/ow-wrappers/ow-game-listener-wrapper.interface';

// -----------------------------------------------------------------------------
// Testable wrapper for game
@injectable()
export class OWGameListenerWrapper
  implements DelegateProvider<IOWGameListenerWrapper>
{
  private readonly listeners: Map<IOWGameListenerWrapper, OWGameListener>;

  // ---------------------------------------------------------------------------
  public constructor() {
    this.listeners = new Map<IOWGameListenerWrapper, OWGameListener>();
  }

  // ---------------------------------------------------------------------------
  // DelegateProvider
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  addListener(listener: IOWGameListenerWrapper) {
    // Make sure we clear callbacks, in case we already have this listener
    this.removeListener(listener);
    this.listeners.set(listener, new OWGameListener(listener, true));
  }

  // ---------------------------------------------------------------------------
  removeListener(listener: IOWGameListenerWrapper) {
    const gameListener = this.listeners.get(listener);
    if (!gameListener) {
      return;
    }

    gameListener.stop();
    this.listeners.delete(listener);
  }
}
